var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "RouterLink",
    {
      staticClass:
        "text-primary-500 hover:text-primary-800 text-sm self-center",
      class: _vm.classes,
      attrs: { to: _vm.routeParams },
    },
    [_vm._v(_vm._s(_vm.content))]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }